import React, {
  useState,
  useEffect,
  useContext,
  createContext,
  useCallback,
} from "react";
import { toast } from "react-toastify";

const url = "https://www.thecocktaildb.com/api/json/v1/1/search.php?s=";

const myContext = createContext();

export const MyAppProvider = ({ children }) => {
  const [loading, setLoading] = useState(false);
  const [searchInput, setSearchInput] = useState("a");
  const [cocktails, setCocktails] = useState([]);
  const [token, setToken] = useState([]);
  const [runToken, setRunToken] = useState(0);
  const [purchaseData, setPurchaseData] = useState(null);
  const [isCheckDetails, setCheckDetails] = useState(false);
  const [isPaymentTrue, setIsPaymentTrue] = useState(false);
  const [isCartAddBtnClicked, setIsCartAddBtnClicked] = useState(false);
  const [path, setPath] = useState();
  const [runPath, setRunPath] = useState(0);
  // this for running useEffect if user change route
  const toggleRunPath = () => {
    setRunPath((prev) => {
      return prev + 1;
    });
  };

  // getting token data
  useEffect(() => {
    const getLocalToken = localStorage.getItem("CocktailToken") || [];
    setToken(getLocalToken);
  }, [runToken]);
  // console.log(token);

  const FetchingData = useCallback(async () => {
    setLoading(true);
    try {
      const response = await fetch(`${url}${searchInput}`);
      const jsonResponse = await response.json();
      const { drinks } = jsonResponse;
      //   console.log(drinks);
      if (drinks) {
        const NewDrinks = drinks.map((drink) => {
          const {
            idDrink: id,
            strAlcoholic: type,
            strCategory: category,
            strDrink: name,
            strDrinkThumb: img,
            strGlass: glass,
          } = drink;
          return { id, type, category, name, img, glass };
        });
        setCocktails(NewDrinks);
      } else {
        setCocktails([]);
      }
    } catch (error) {
      console.log(error);
    }
    setLoading(false);
  }, [searchInput]);

  useEffect(() => {
    FetchingData();
  }, [searchInput, FetchingData]);
  //   console.log(cocktails);

  // all the cart state and functionality start from below
  const [localCart, setLocalCart] = useState([]);
  const [run, setRun] = useState(false);
  const getLocalCart = JSON.parse(localStorage.getItem("CocktailCart")) || [];
  useEffect(() => {
    setLocalCart(getLocalCart);
  }, [run]);

  const toggleRun = () => {
    setRun(!run);
  };

  // cart functionality start from below
  const add = (id) => {
    const findProduct = cocktails?.filter((singleProduct) => {
      return singleProduct.id === id;
    });
    const isProductExist = getLocalCart?.find((item) => {
      return item.id === id;
    });
    if (isProductExist) {
      const findOne = getLocalCart?.map((item) => {
        return item.id === id
          ? { ...isProductExist, quantity: isProductExist.quantity + 1 }
          : item;
      });
      localStorage.setItem("CocktailCart", JSON.stringify(findOne));
      toast.success("Item quantity increased!", {
        position: "top-center",
        autoClose: 1000,
      });
    } else {
      localStorage.setItem(
        "CocktailCart",
        JSON.stringify([...localCart, { ...findProduct[0], quantity: 1 }])
      );
      toast.success("Item added to cart.", {
        position: "top-center",
        autoClose: 1000,
      });
    }
    toggleRun();
  };
  const handleRemoveQuantity = (id) => {
    const isProductExist = getLocalCart?.find((item) => {
      return item.id === id;
    });
    if (isProductExist.quantity === 1) {
      const filterRemoveSingle = getLocalCart?.filter((singleItem) => {
        return singleItem.id !== id;
      });
      localStorage.setItem("CocktailCart", JSON.stringify(filterRemoveSingle));
      toast.success("Item removed from cart!", {
        position: "top-center",
        autoClose: 1000,
      });
    } else {
      const findOneAndDecreaseQuantity = getLocalCart?.map((item) => {
        return item.id === id
          ? { ...isProductExist, quantity: isProductExist.quantity - 1 }
          : item;
      });
      localStorage.setItem(
        "CocktailCart",
        JSON.stringify(findOneAndDecreaseQuantity)
      );
      toast.success("Item quantity decreased!", {
        position: "top-center",
        autoClose: 1000,
      });
    }
    toggleRun();
  };
  const remove = (id) => {
    const filterRemoveSingleItem = getLocalCart?.filter((item) => {
      return item.id !== id;
    });
    localStorage.setItem(
      "CocktailCart",
      JSON.stringify(filterRemoveSingleItem)
    );
    toast.success("Item removed from cart!", {
      position: "top-center",
      autoClose: 1000,
    });
    toggleRun();
  };
  const ClearCart = () => {
    localStorage.removeItem("CocktailCart");
    toast.success("Item removed from cart!", {
      position: "top-center",
      autoClose: 1000,
    });
    toggleRun();
  };
  const totalItem = localCart?.reduce(
    (quantity, item) => quantity + item.quantity,
    0
  );
  const totalPrice = localCart
    ?.reduce(
      (price, item) => price + parseFloat(item.id / 5000) * item.quantity,
      0
    )
    .toFixed(1);
  // end of cart functionality
  return (
    <myContext.Provider
      value={{
        loading,
        cocktails,
        localCart,
        setSearchInput,
        add,
        handleRemoveQuantity,
        remove,
        ClearCart,
        totalPrice,
        totalItem,
        setRunToken,
        token,
        purchaseData,
        setPurchaseData,
        isCheckDetails,
        setCheckDetails,
        isPaymentTrue,
        setIsPaymentTrue,
        toggleRun,
        isCartAddBtnClicked,
        setIsCartAddBtnClicked,
        path,
        setPath,
        runPath,
        toggleRunPath,
      }}
    >
      {children}
    </myContext.Provider>
  );
};

export const MyGlobalContext = () => {
  return useContext(myContext);
};
